import { SalePromoCodeController as controller } from './sale-promo-code.controller'
import template from './sale-promo-code.html'

export const SalePromoCodeComponent = {
  bindings: {
    shouldShowLink: '<',
  },
  controller,
  template,
}
